import React from 'react';

const BlogCategoryForm = ({ formData, errors, handleChange }) => {
  return (
    <div className="admin__modal-column">
      <div className="form-group">
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Category Name*"
          className={errors.name ? 'error' : ''}
          maxLength="100"
        />
        <div className="error-message-container">
          <p className="error-message">{errors.name}</p>
        </div>
      </div>

      <div className="form-group">
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="Category Description"
          rows="4"
          className={errors.description ? 'error' : ''}
        />
        <div className="error-message-container">
          <p className="error-message">{errors.description}</p>
        </div>
      </div>

      <div className="form-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            name="is_active"
            checked={formData.is_active}
            onChange={handleChange}
          />
          Active Category
        </label>
        <div className="error-message-container">
          <p className="error-message">{errors.is_active}</p>
        </div>
      </div>
    </div>
  );
};

export default BlogCategoryForm; 